module.exports = __webpack_public_path__ + "img/build.d0312f10.svg";